export const getFullName = (firstName, lastName) => {
  let fullName = firstName || "";
  if (fullName && lastName) {
    fullName += " " + lastName;
  } else if (lastName) {
    fullName = lastName;
  }
  return fullName;
};

export const uniqueId = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "_" + Math.random().toString(36).substring(2, 9);
};

export function isStringNumeric(str) {
  if (typeof str !== "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}
